var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-57.6 -53.49525 499.2 320.9715",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs312"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style310"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-64 -64.45)",
    id: "g316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path314",
    d: "M220.9 128.45l-14.45 14.46L192 128.45 206.45 114zM256 93.36l24.77 24.77 14.46-14.45L256 64.45l-39.23 39.23 14.46 14.45zM305.55 114l-14.45 14.45 14.45 14.46L320 128.45zM256 163.55l-24.77-24.77-14.46 14.45L256 192.45l39.23-39.22-14.46-14.45zm0-20.64l14.45-14.46L256 114l-14.45 14.45zM111.75 262.14V262c0-7.55-4-11.32-10.51-13.81 4-2.24 7.38-5.77 7.38-12.11v-.16c0-8.83-7.06-14.53-18.54-14.53H64v56.18h26.72c12.68-.02 21.03-5.16 21.03-15.43zm-15.41-24c0 4.18-3.45 5.94-8.91 5.94H76V232.2h12.2c5.21 0 8.1 2.09 8.1 5.78zm3.13 22.47c0 4.18-3.29 6.1-8.75 6.1H76v-12.36h14.32c6.34 0 9.15 2.33 9.15 6.1zm38.2 16.94v-56.18h-12.36v56.18zm66.43 0v-56.18h-12.2V256l-26.32-34.59h-11.4v56.18h12.2v-35.76l27.21 35.72zm68.46 0L248.48 221h-11.39L213 277.55h12.6l5.14-12.6h23.76l5.14 12.6zM250.09 254h-14.93l7.46-18.21zm81.38 23.52v-56.15h-12.2V256L293 221.37h-11.4v56.18h12.2v-35.72l27.2 35.72zm63.8-9.07l-7.86-8c-4.42 4-8.35 6.58-14.77 6.58-9.63 0-16.29-8-16.29-17.65v-.16c0-9.63 6.82-17.5 16.29-17.5 5.62 0 10 2.41 14.37 6.34l7.86-9.07c-5.22-5.13-11.56-8.66-22.15-8.66-17.25 0-29.29 13.08-29.29 29.05v.16c0 16.13 12.28 28.89 28.81 28.89 10.83.08 17.25-3.77 23.03-9.95zm52.73 9.1v-11h-30.5v-11.8H444v-11h-26.5v-11.38h30.1v-11h-42.37v56.18z",
    fill: "#f0b90b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinance);
export default __webpack_public_path__ + "static/media/binance.8ae3eba6f6e4ae6f8659a2b403ffb909.svg";
export { ForwardRef as ReactComponent };